import { Checkbox, Popup } from "semantic-ui-react";
import { ConfirmBoxOptionsType } from "../../reducer/type";
import { Dispatch, SetStateAction } from "react";

type CascadeLBDeleteProps = {
  options: ConfirmBoxOptionsType;
  setOptions: Dispatch<SetStateAction<ConfirmBoxOptionsType>>;
};

const CascadeLBDelete = ({ options, setOptions }: CascadeLBDeleteProps) => {
  const onChange = () => {
    setOptions((prevOptions) => ({
      ...prevOptions,
      cascade: !options.cascade,
    }));
  };
  return (
    <Popup
      trigger={
        <Checkbox
          className="simple-checkbox margin-top-half color-gray"
          label="Use cascade feature"
          checked={options.cascade}
          onChange={onChange}
        />
      }
    >
      <div>
        Using cascade feature will automatically delete all the children that
        belong to the specified loadbalancer (pool, members, listeners, etc).
      </div>
    </Popup>
  );
};

export default CascadeLBDelete;
